import React from 'react';

import { AuthProvider } from '../auth';
import { AuthAppContext } from './auth-app.context';
import { AuthCompanyProvider } from '../auth-company';

export function AuthAppProvider({
  children,
  apiUrl
}: {
  children: React.ReactNode;
  apiUrl?: string;
}): JSX.Element {
  return (
    <AuthAppContext.Provider value={{ appApiUrl: apiUrl ?? process.env.REACT_APP_API_URL }}>
      <AuthProvider>
        <AuthCompanyProvider>{children}</AuthCompanyProvider>
      </AuthProvider>
    </AuthAppContext.Provider>
  );
}
